<template>
  <div class="input-group">
    <span class="input-group-text"><font-awesome-icon :icon="['fas', 'shelves']" /></span>
    <select id="pullType" name="pullType" required v-model="selectedPullType" class="form-select">
      <option v-for="pullType in RESTOCK_PULL_TYPE" :key="pullType" :value="pullType">{{ $t(`enum.restockPullType.${pullType}`) }}</option>
    </select>
  </div>
</template>

<script setup lang="ts">

import { RestockPullType, RESTOCK_PULL_TYPE } from "@/models/Enums";
import { onMounted, PropType, ref, watch } from "vue";

const selectedPullType = ref<RestockPullType>(RESTOCK_PULL_TYPE.onDemand)

const props = defineProps({
  predefinedPullType: { type: Number as PropType<RestockPullType>, required: true }
})
const emit = defineEmits<{ (e: 'pullTypeSelected', pullType: RestockPullType): void }>();

onMounted(() => {
  selectedPullType.value = props.predefinedPullType ?? RESTOCK_PULL_TYPE.onDemand;
});

watch(() => props.predefinedPullType, async (newPullType: RestockPullType | undefined) => {
  selectedPullType.value = newPullType ?? RESTOCK_PULL_TYPE.onDemand;
});

watch(() => selectedPullType.value, async (newPullType: RestockPullType) => {
  emit('pullTypeSelected', newPullType);
});

</script>
